// TODO: Replace colors and sizes for global vars.

import styled from '@emotion/styled';

export const FieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-bottom: 16px;
`;

export const FieldLabel = styled.div`
  font-weight: 700;
  color: #333333;
  font-size: 14px;
  margin-bottom: 14px;
`;

export const FieldInline = styled.div`
  display: inline-flex;

  .MuiInputBase-root {
    background-color: white;
    border-radius: 4px;
    overflow: hidden;
    color: #66788a;
    font-size: 16px;
  }

  &:not(:last-child) {
    margin-right: 16px;
  }
`;

export const FieldComponent = styled.div`
  flex-grow: 1;
  display: flex;
`;

export const SubmitWrapper = styled.div<{ isEdit?: boolean }>`
  width: 100%;
  display: flex;
  justify-content: ${(props) => (props.isEdit ? 'space-evenly' : 'center')};
  margin-top: 16px;

  .MuiButton-root {
    min-width: ${(props) => (props.isEdit ? '40%' : '80%')};
  }
`;

export const Description = styled.p`
  margin: 16px 0;
  color: #333333;
  font-size: 14px;
`;

export const Header = styled.p`
  margin: 16px 0;
  color: #333333;
  font-size: 14px;
  text-align: center;
`;

export const Title = styled.h2`
  color: #333333;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
`;

export const ModalWrapper = styled.div`
  background-color: #ebf1f7;
  box-sizing: border-box;
  padding: 16px;
  min-width: 300px;
  max-width: 600px;
  width: 95%;
  margin: 16px auto;
  border-radius: 10px;
`;

export const TopBox = styled.div`
  display: flex;
  width: 100%;
`;

export const CloseBtn = styled.div`
  cursor: pointer;
`;

export const PaymentBottomButtonWrapper = styled.div`
  width: 100vw;
  bottom: 0;
  inset: auto 0 0 0;
  padding: 20px;
  box-shadow: 0px 0px 23px rgba(0, 0, 0, 0.11);
  text-align: center;
  background-color: #fff;

  button {
    min-width: 118px;
  }
`;
